import React from 'react'
import { createRoot } from 'react-dom/client'

import { ChartView } from '../components/ChartView'
import { BabyNameLookup } from '../components/BabyNameLookup'
import { BankLookup } from '../components/BankLookup'
import { CompanyLookup } from '../components/CompanyLookup'
import { CountryCompare } from '../components/CountryCompare'
import { NflTeamLookup } from '../components/NflTeamLookup'
import { RankingView } from '../components/RankingView'
import { StateCrimeLookup } from '../components/StateCrimeLookup'
import { ZipCodeLookup } from '../components/ZipCodeLookup'

const LOOKUPS = { baby_names: BabyNameLookup, world_countries: CountryCompare, companies: CompanyLookup, zip_codes: ZipCodeLookup, banks: BankLookup, state_crime: StateCrimeLookup, nfl_teams: NflTeamLookup }
const roots = new Map()

// A slot holds the chart's room (application.css) until the drawing is there,
// or a moment later for a chart with no drawing yet, so the page never jumps.
function releaseSlot(el) {
  const release = () => {
    observer.disconnect()
    clearTimeout(timer)
    el.dataset.mounted = ''
  }
  const observer = new MutationObserver(() => {
    if (el.querySelector('svg')) release()
  })
  const timer = setTimeout(release, 1000)
  observer.observe(el, { childList: true, subtree: true })
}

// Public chart pages render server-side (question, takeaway, source, data
// table); this mounts the interactive chart into each `[data-chart]` slot.
function mountCharts() {
  document.querySelectorAll('[data-chart]').forEach((el) => {
    if (roots.has(el)) return
    let chart
    try {
      chart = JSON.parse(el.dataset.chart)
    } catch {
      return
    }
    const Component = LOOKUPS[chart.lookup] ?? (chart.ranking ? RankingView : ChartView)
    const root = createRoot(el)
    root.render(<Component chart={chart} />)
    releaseSlot(el)
    roots.set(el, root)
  })
}

// Turbo Drive swaps pages without reloading this module, so mount again on
// every Turbo visit (links and the back button). Unmount before Turbo caches a
// page, so a restored page gets a live chart rather than a lifeless copy.
function unmountCharts() {
  roots.forEach((root, el) => {
    root.unmount()
    delete el.dataset.mounted
  })
  roots.clear()
}

mountCharts()
document.addEventListener('turbo:load', mountCharts)
document.addEventListener('turbo:before-cache', unmountCharts)
